import { NavLink } from 'react-router';

import type {
  NavItem as BumblebeeNavItem,
  PrimaryNavProps as BumblebeePrimaryNavProps,
} from '@shieldpay/bumblebee/primary-nav';
import { PrimaryNav as BumblebeePrimaryNav } from '@shieldpay/bumblebee/primary-nav';

import type { RemoveNavLinkProperty } from '../../utilities/remove-navlink-property';

const PrimaryNav = ({
  children,
  background,
  gridItem,
}: BumblebeePrimaryNavProps) => {
  return (
    <BumblebeePrimaryNav
      background={background}
      children={children}
      gridItem={gridItem}
    />
  );
};

PrimaryNav.Item = (props: RemoveNavLinkProperty<BumblebeeNavItem>) => {
  return <BumblebeePrimaryNav.Item NavLink={NavLink} {...props} />;
};

PrimaryNav.Heading = BumblebeePrimaryNav.Heading;

export { PrimaryNav };
